<div class="org-admin-dashboard" *ngIf="canAccess && !isChecking">
  <div class="org-admin-dashboard--layout">
    <app-org-admin-sidebar class="org-admin-dashboard--sidebar"></app-org-admin-sidebar>
    <div class="org-admin-dashboard--content">
      <app-page-header></app-page-header>
      <div class="page-container">
        <app-pickup-things></app-pickup-things>
        
        <!-- Recent Activities Section -->
        <div class="recent-activities">
          <div class="recent-activities__header">
            <h5 class="recent-activities__title">Recent Activities</h5>
            <a routerLink="/org-admin/activities" class="recent-activities__view-all">
              View All
              <img src="/arrow-right.svg" alt="Arrow right" width="16" height="16" />
            </a>
          </div>
          <app-activities
            [showFilters]="false"
            [pageSize]="5"
            [showPagination]="false"
            [disableSorting]="true"
            [showExportButton]="false"
          ></app-activities>
        </div>
      </div>
    </div>
  </div>
</div>
